import React, { useContext } from 'react';
import TargetFormContext from '../../contexts/TargetFormContext';
import Typography from '../../../../kingpin/atoms/Typography';
import { BadgeDiv } from '../../../Badge';
import { AvatarColors } from '../../../../theme/tokens';

const RuleNumber = ({ group }: { group: Targets.Wizard.TargetGroup }) => {
  const { groups } = useContext(TargetFormContext);
  const index = groups.findIndex((g) => g.key === group.key);
  const text = `RULE ${index + 1}`;
  const { colorIndex } = group;
  const backgroundColor = AvatarColors[colorIndex].background;
  const textColor = AvatarColors[colorIndex].text;

  return (
    <div style={{ marginRight: 16 }}>
      <BadgeDiv backgroundColor={backgroundColor} borderColor={textColor}>
        <Typography.Body type={'Badge'}>{text}</Typography.Body>
      </BadgeDiv>
    </div>
  );
};

export default RuleNumber;
